import { useFormikContext } from "formik";
import { HTMLInputTypeAttribute } from "react";
import IconExclamation from "../icons/IconExclamation";


interface iInputProps{
    type:HTMLInputTypeAttribute,
    name: string,
    placeholder: string
}

interface iInitialValues{
    name:string,
    email: string,
    contact: string,
    location:string
}

export default function ValidationInput({type, name, placeholder}:iInputProps) {

    const {values, setFieldTouched, setFieldValue, errors, touched} = useFormikContext<iInitialValues>()

  return (
    <label htmlFor={name} className="w-full text-lg flex flex-col mt-8 relative">
        <input 
            type={type} 
            name={name}
            className="w-full bg-inherit border-b rounded-none placeholder:text-white/50 text-white mt-1"
            placeholder={placeholder}
            value={values[name as keyof iInitialValues]}
            onBlur={()=>setFieldTouched(name)}
            onChange={({target})=>setFieldValue(name, target.value)}
        />
        {
            (errors[name as keyof iInitialValues] && touched[name as keyof iInitialValues]) && <div className="form-exclamation w-1 h-1 absolute right-2">
            <IconExclamation/>
        </div>
        }
    </label>
  )
}